import { useThemeStore } from '@/stores/theme'
import { useWhiteLabelStore } from '@/stores/white-label'

import { SignaterLogo } from '../signater-logo'

interface BrandLogoProps {
  className?: string
  size?: number
  variant?: 'rectangle' | 'square'
}

export function BrandLogo({
  className,
  size = 32,
  variant = 'rectangle',
}: BrandLogoProps) {
  const {
    isWhiteLabel,
    companyName,
    rectangleLightLogoUrl,
    rectangleDarkLogoUrl,
    squareLightLogoUrl,
    squareDarkLogoUrl,
  } = useWhiteLabelStore()
  const theme = useThemeStore((state) => state.theme)

  // Determine if we're in dark mode
  const isDark = theme === 'dark'

  // Select the appropriate logo URL based on variant and theme
  let logoUrl: string | null = null

  if (isWhiteLabel) {
    if (variant === 'rectangle') {
      logoUrl = isDark ? rectangleDarkLogoUrl : rectangleLightLogoUrl
    } else {
      logoUrl = isDark ? squareDarkLogoUrl : squareLightLogoUrl
    }
  }

  // If no white-label logo is available, use the default Signater logo
  if (!logoUrl) {
    return <SignaterLogo className={className} size={size} variant={variant} />
  }

  const alt = `${companyName} Logo`.trim() || 'Brand Logo'

  return (
    <img
      src={logoUrl}
      alt={alt}
      className={className}
      style={{ height: size, width: 'auto' }}
    />
  )
}
